module.exports = __webpack_public_path__ + "cv.svg?0b63fdcac9f8337b4e84d7666619caae";